import { ItemSetProvider } from '@exam-management/common/item-set-provider';
import { QContentProvider } from '@exam-management/common/qcontent-provider';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import {
  ItemSetSubQuestionDetailHeader,
  ItemSetSubQuestionEditForm,
  QContentDetailsModalProvider,
} from '@exam-management/qcontent-detail';
import { useParams } from '@exam-management/router';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function ItemSetSubQuestionDetailLayout() {
  const { questionId, subQuestionId, structureId } = useParams(
    '/qbank-structures/:structureId/qcontents/item-set/:questionId/:subQuestionId',
  );

  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.QBANK.QUESTION.VIEW}>
      <QContentProvider contentId={subQuestionId} structureId={structureId}>
        <ItemSetProvider itemSetId={questionId}>
          <ItemSetSubQuestionDetailHeader />
          <ItemSetSubQuestionEditForm>
            <QContentDetailsModalProvider>
              <Outlet />
            </QContentDetailsModalProvider>
          </ItemSetSubQuestionEditForm>
        </ItemSetProvider>
      </QContentProvider>
    </PermissionGuard>
  );
}
